import { Schema, z } from 'zod';
import { BaseFieldDefinition, BaseFieldDefinitionSchema } from './base';
import { FieldDefinition, FieldDefinitionSchema } from './composite';

export namespace ArrayFieldDefinition {
  export const TYPE = 'array';
}

/**
 * Field definition of type array
 * @typedef ArrayFieldDefinition
 * @property - type : type of the field.
 * @property - fieldDefinition : type of the elements within the array.
 * @property - validations : an optional object for defining rules about how a module definition can be instantiated.
 */

export type ArrayFieldDefinition = BaseFieldDefinition & {
  type: typeof ArrayFieldDefinition.TYPE;
  fieldDefinition: FieldDefinition;
  validations?: {
    minItems?: number;
    maxItems?: number;
    hasUniqueItems?: boolean;
  };
};

export const ArrayFieldDefinitionSchema: Schema<ArrayFieldDefinition> =
  BaseFieldDefinitionSchema.and(
    z.object({
      type: z.literal(ArrayFieldDefinition.TYPE),
      fieldDefinition: z.lazy(() => FieldDefinitionSchema),
      validations: z
        .object({
          minItems: z.number().optional(),
          maxItems: z.number().optional(),
          hasUniqueItems: z.boolean().optional()
        })
        .optional()
    })
  );
